function handlePopoverCloseOnClick() {
    const popoverTargets = document.querySelectorAll("[popovertarget][data-close]");
    popoverTargets.forEach((target) => {
        target.addEventListener("click", () => {
            const closeTime = parseInt(target.getAttribute("data-close") ?? "2000", 10);
            const popover = document.querySelector(`#${target.getAttribute("popovertarget")}`) as HTMLElement;

            const progressBar = document.createElement("div");
            progressBar.style.cssText = `
                position: absolute;
                bottom: 0;
                left: 0;
                height: 4px;
                width: 0;
                background-color: var(--_progress-color, currentColor);
                transition: width ${closeTime}ms linear;
            `;
            popover.appendChild(progressBar);

            requestAnimationFrame(() => {
                progressBar.style.width = "100%";
            });

            setTimeout(() => {
                progressBar.style.width = "0";
                popover.hidePopover();
            }, closeTime);
        });
    });
}

document.addEventListener("DOMContentLoaded", handlePopoverCloseOnClick);
